import { unsafeCSSVarV2 } from '@blocksuite/affine-shared/theme';
import { css, html, unsafeCSS } from 'lit';
// @ts-ignore
import cssText from './video.css?inline';

export const styles = [
  unsafeCSS(cssText),
  css`
    .affine-embed-videojs-block {
      background: #00000005;
      box-sizing: border-box;
      width: 100%;
      height: 100%;

      display: flex;
      flex-direction: column;
      gap: 20px;
      padding: 12px;

      border-radius: 8px;
      border: 1px solid ${unsafeCSSVarV2('layer/background/tertiary')};

      user-select: none;
    }

    .affine-embed-videojs-video {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 1;
      width: 100%;
    }

    .affine-embed-videojs-video img,
    .affine-embed-videojs-video object,
    .affine-embed-videojs-video svg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }

    .affine-embed-videojs-video-iframe-container {
      position: relative;
      height: 100%;
    }

    .affine-embed-videojs-video-iframe-container > iframe {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }

    .affine-embed-videojs-video-iframe-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .affine-embed-videojs-video-iframe-overlay.hide {
      display: none;
    }

    .affine-embed-videojs-content {
      display: block;
      flex-direction: column;
      width: 100%;
      height: fit-content;
    }

    .affine-embed-videojs-content-url {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 4px;
      width: max-content;
      max-width: 100%;
      cursor: pointer;
    }
    .affine-embed-videojs-content-url > a {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;

      word-break: break-all;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      color: ${unsafeCSSVarV2('icon/primary')};

      font-family: var(--affine-font-family);
      font-size: var(--affine-font-xs);
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
    .affine-embed-videojs-content-url:hover > a {
      color: var(--affine-link-color);
    }
    .affine-embed-videojs-content-url:hover .open-icon {
      fill: var(--affine-link-color);
    }

    .affine-embed-videojs-content-url-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 12px;
      height: 12px;
    }
    .affine-embed-videojs-content-url-icon svg {
      height: 12px;
      width: 12px;
      fill: ${unsafeCSSVarV2('icon/primary')};
    }

    .affine-embed-videojs-block.loading {
      .affine-embed-videojs-content-title-text {
        color: var(--affine-placeholder-color);
      }
    }

    .affine-embed-videojs-block.selected {
      .affine-embed-videojs-content-url > span {
        color: var(--affine-link-color);
      }
      .affine-embed-videojs-content-url .open-icon {
        fill: var(--affine-link-color);
      }
    }
  `,
];

export const VideoIcon = html`<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g opacity="0.9">
    <path
      d="M7.53464 10.3439L7.34923 10.7676C7.32024 10.8364 7.27155 10.8952 7.20927 10.9366C7.14698 10.9779 7.07387 11 6.9991 11C6.92433 11 6.85122 10.9779 6.78893 10.9366C6.72665 10.8952 6.67796 10.8364 6.64897 10.7676L6.46446 10.3439C6.14022 9.59282 5.54612 8.99043 4.79934 8.65555L4.2305 8.40189C4.16166 8.36999 4.10338 8.31909 4.06254 8.25518C4.0217 8.19127 4 8.11702 4 8.04119C4 7.96536 4.0217 7.89111 4.06254 7.8272C4.10338 7.76329 4.16166 7.71239 4.2305 7.68049L4.76784 7.44123C5.53339 7.09784 6.13782 6.47383 6.45636 5.698L6.64627 5.24016C6.67426 5.16933 6.72292 5.10856 6.78592 5.06573C6.84892 5.0229 6.92335 5 6.99955 5C7.07575 5 7.15018 5.0229 7.21318 5.06573C7.27618 5.10856 7.32484 5.16933 7.35283 5.24016L7.54184 5.6989C7.86079 6.47456 8.46554 7.09824 9.23126 7.44123L9.7695 7.68049C9.83834 7.71239 9.89662 7.76329 9.93746 7.8272C9.9783 7.89111 10 7.96536 10 8.04119C10 8.11702 9.9783 8.19127 9.93746 8.25518C9.89662 8.31909 9.83834 8.36999 9.7695 8.40189L9.19976 8.65555C8.45314 8.99021 7.85906 9.59316 7.53464 10.3439Z"
      fill="black"
    />
    <path
      d="M15 10.5L17.4 8.7C18.0592 8.20557 19 8.67595 19 9.5V14.5C19 15.324 18.0592 15.7944 17.4 15.3L15 13.5"
      stroke="black"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M11.5 7H13C14.1046 7 15 7.89543 15 9V15C15 16.1046 14.1046 17 13 17H7C5.89543 17 5 16.1046 5 15V12"
      stroke="black"
      stroke-width="1.2"
      stroke-linecap="round"
    />
  </g>
</svg> `;
